import { render, staticRenderFns } from "./HomeBill.vue?vue&type=template&id=2f6d9214&"
import script from "./HomeBill.vue?vue&type=script&lang=js&"
export * from "./HomeBill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports